import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import { currencyFormatter } from '@/app/common/utilities'
import { SelectedPurse } from '@/storage/applications/providerPaySlice'
import { useTranslation } from 'react-i18next'
import { getTotalAllocated } from './purse_allocation.utils'
import { ApplicantPaymentAmount } from '../../payment.utils'

interface PurseAllocationSummaryProps {
  selectedPurses: SelectedPurse[]
  total: ApplicantPaymentAmount
}

export const PurseAllocationSummary = ({
  selectedPurses,
  total,
}: PurseAllocationSummaryProps) => {
  const { t: translate } = useTranslation()

  const totalAllocated = getTotalAllocated(selectedPurses)

  const remainingToAllocate = total - totalAllocated

  return (
    <Card>
      <CardHeader>
        <p className="text-sm font-medium">{translate('allocation_summary')}</p>
      </CardHeader>
      <CardContent>
        <p className="flex w-full text-base text-gray-700 justify-between font-normal">
          <span>{translate('allocated_amount')}:</span>
          <span className="font-medium">
            {currencyFormatter.format(totalAllocated)}
          </span>
        </p>
        <p className="flex w-full text-base text-gray-700 justify-between font-normal">
          <span>{translate('remaining_to_allocate')}:</span>
          <span
            className={`font-medium ${remainingToAllocate !== 0 ? 'text-red-600' : 'text-green-600'}`}
          >
            {currencyFormatter.format(remainingToAllocate)}
          </span>
        </p>
      </CardContent>
    </Card>
  )
}
